import { render, staticRenderFns } from "./SitaMenue.vue?vue&type=template&id=79eae869&scoped=true"
import script from "./SitaMenue.vue?vue&type=script&lang=js"
export * from "./SitaMenue.vue?vue&type=script&lang=js"
import style0 from "./SitaMenue.vue?vue&type=style&index=0&id=79eae869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eae869",
  null
  
)

export default component.exports